module.exports = __webpack_public_path__ + "static/share-logo-9b60e07e518ebe2cf0fcbec1f36778b8.png";